import formatAmount from "utils/formatAmount";
import { FormattedMessage } from "react-intl";

import {
  StyledTicketPoolSummaryList,
  StyledTicketPoolSummaryListItem,
} from "./styles";
import { TicketPoolSummaryListProps } from "./types";

const TicketPoolSummaryList: React.FC<TicketPoolSummaryListProps> = ({
  items,
  count,
}) => {
  const itemsCount = items?.length || 0;
  const totalCount = count || 0;
  const moreCount = totalCount > itemsCount ? totalCount - itemsCount + 1 : 0;
  const sliceEnd = moreCount ? itemsCount - 1 : undefined;

  return (
    <StyledTicketPoolSummaryList>
      {items
        ?.slice(0, sliceEnd)
        .map(({ id, name, price, venueFee, quantity }) => (
          <StyledTicketPoolSummaryListItem key={id}>
            {name} / {formatAmount(price)} / {formatAmount(venueFee)} /{" "}
            {quantity}
          </StyledTicketPoolSummaryListItem>
        ))}
      {moreCount > 0 && (
        <FormattedMessage
          defaultMessage="and {count} more"
          values={{ count: moreCount }}
        />
      )}
    </StyledTicketPoolSummaryList>
  );
};

export default TicketPoolSummaryList;
